/**
 * Watermark configuration types for PixelShare
 */

export type WatermarkType = 'text' | 'image';

export type WatermarkPosition =
  | 'center'
  | 'top-left'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right'
  | 'tile';

export interface WatermarkConfig {
  enabled: boolean;
  type: WatermarkType;

  // Text watermark options
  text?: string;
  fontFamily: string;
  fontSize: number;
  fontColor: string;

  // Image watermark options
  imageS3Key?: string;
  imagePreviewUrl?: string;

  // Position and appearance
  position: WatermarkPosition;
  opacity: number;
  scale: number;
  margin: number;
}

export interface GallerySettings {
  watermarkEnabled: boolean;
  watermarkConfig: WatermarkConfig;
  downloadEnabled: boolean;
  socialSharingEnabled: boolean;
  theme: 'elegant' | 'modern' | 'classic' | 'professional';
  customCss?: string;
  passwordProtected: boolean;
  password?: string;
  allowGuestUploads: boolean;
}

// Default watermark configuration
export const DEFAULT_WATERMARK_CONFIG: WatermarkConfig = {
  enabled: true,
  type: 'text',
  text: '',
  fontFamily: 'Arial',
  fontSize: 36,
  fontColor: '#FFFFFF',
  position: 'bottom-right',
  opacity: 0.5,
  scale: 0.15,
  margin: 20,
};

// Default gallery settings
export const DEFAULT_GALLERY_SETTINGS: GallerySettings = {
  watermarkEnabled: true,
  watermarkConfig: DEFAULT_WATERMARK_CONFIG,
  downloadEnabled: true,
  socialSharingEnabled: true,
  theme: 'elegant',
  passwordProtected: false,
  allowGuestUploads: false,
};

// Font options for watermark
export const WATERMARK_FONT_OPTIONS = [
  { value: 'Arial', label: 'Arial' },
  { value: 'Helvetica', label: 'Helvetica' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Verdana', label: 'Verdana' },
  { value: 'Courier New', label: 'Courier New' },
];

// Position options for watermark
export const WATERMARK_POSITION_OPTIONS: {
  value: WatermarkPosition;
  label: string;
  icon: string;
}[] = [
  { value: 'top-left', label: 'Top Left', icon: '↖' },
  { value: 'top-right', label: 'Top Right', icon: '↗' },
  { value: 'center', label: 'Center', icon: '⊕' },
  { value: 'bottom-left', label: 'Bottom Left', icon: '↙' },
  { value: 'bottom-right', label: 'Bottom Right', icon: '↘' },
  { value: 'tile', label: 'Tile (Repeat)', icon: '⊞' },
];
